import { DialoguePage } from './DialoguePage';
export default DialoguePage;
